import React from 'react';
import { usePathname } from 'src/hooks/router-hooks';
import { ORGANIZATION_ID, SITE_URL, WEBSITE_ID } from 'src/constants/schema';

import { Schema } from '../Schema/Schema';

export const BrandSchema: React.FC = React.memo(() => {
    const pathname = usePathname();

    if (pathname !== '/') {
        return null;
    }

    return (
        <>
            <Schema
                input={{
                    '@context': 'https://schema.org',
                    '@type': 'Organization',
                    '@id': ORGANIZATION_ID,
                    name: 'Workwear Express',
                    url: `${SITE_URL}/`,
                    description:
                        'Workwear Express is a UK workwear and corporate clothing supplier, offering personalised uniforms, branded workwear, and protective clothing for businesses of all sizes.',
                    logo: {
                        '@type': 'ImageObject',
                        url: `${SITE_URL}/static/icons/og-logo.jpg`,
                    },
                    sameAs: [
                        'https://www.facebook.com/Workwearexpressltd/',
                        'https://www.instagram.com/workwearexpress/',
                        'https://x.com/workwearexpress',
                        'https://www.youtube.com/channel/UClvfQROSDFjbdXs75u6-QCg',
                    ],
                    address: {
                        '@type': 'PostalAddress',
                        streetAddress: 'Cathedral Park, Belmont Industrial Estate',
                        addressLocality: 'Durham',
                        postalCode: 'DH1 1TF',
                        addressCountry: 'GB',
                    },
                    telephone: '+448000285867',
                    contactPoint: [
                        {
                            '@type': 'ContactPoint',
                            telephone: '+448000285867',
                            contactType: 'customer service',
                            email: 'CustomerSupport@WorkwearExpress.com',
                            availableLanguage: 'English',
                            hoursAvailable: [
                                {
                                    '@type': 'OpeningHoursSpecification',
                                    dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
                                    opens: '08:00',
                                    closes: '18:00',
                                },
                                {
                                    '@type': 'OpeningHoursSpecification',
                                    dayOfWeek: 'Saturday',
                                    opens: '09:00',
                                    closes: '13:00',
                                },
                            ],
                        },
                        {
                            '@type': 'ContactPoint',
                            contactType: 'sales',
                            email: 'Sales@WorkwearExpress.com',
                            availableLanguage: 'English',
                        },
                    ],
                }}
            />
            <Schema
                input={{
                    '@context': 'https://schema.org',
                    '@type': 'WebSite',
                    '@id': WEBSITE_ID,
                    name: 'Workwear Express',
                    url: `${SITE_URL}/`,
                    potentialAction: [
                        {
                            '@type': 'SearchAction',
                            target: {
                                '@type': 'EntryPoint',
                                urlTemplate: `${SITE_URL}/catalogsearch/results?query={search_term_string}`,
                            },
                            'query-input': 'required name=search_term_string',
                        },
                    ],
                }}
            />
        </>
    );
});
